import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { map } from 'rxjs/operators';
import { SessionService } from '../services/session.service';

@Injectable()
export class IsSuperOpsGuard implements CanActivate {
    constructor(private sessionService: SessionService) {}

    canActivate() {
        return this.sessionService.session$.pipe(map(session => session.hasSuperOps || session.hasSuperAdmin));
    }
}
